(function ($) {
    $(document).ready(function () {
        
        TweenLite.defaultEase = Linear.easeNone;
        var controller = new ScrollMagic.Controller();

        var intViewportHeight = 55;
        if (window.matchMedia("(min-width: 768px)").matches) {
            var intViewportHeight = $('#pinMaster #pinContainer .pin-wrap').outerHeight()/2;
        }
        var pinDurlong = $('#pin-frame-pin .background-features-color').outerHeight() - $('#pinMaster #pinContainer .pin-wrap').outerHeight() + intViewportHeight;
        var tl = new TimelineMax();
        var dur = pinDurlong;
            tl.fromTo("section.panel.turqoise", dur, { y: intViewportHeight }, { y: -dur });   


        new ScrollMagic.Scene({
            triggerElement: ".s-timeline",
            triggerHook: "onLeave",
            duration: "100%"
        })
            .setPin(".s-timeline")
            .setTween(tl)
            .addTo(controller);


        $(window).on('resize scroll', function() {

            $('.c-timeline').each(function() {
                var triggerTop = $('#trigger').offset().top;
                var triggerBottom = triggerTop + $('#trigger').outerHeight();

                var slideTop = $(this).offset().top;
                var slideBottom = slideTop + $(this).outerHeight();
                if (triggerTop > slideTop && triggerBottom < slideBottom) {
                    $(this).addClass('active');
                    
                } else {
                    $(this).removeClass('active');
                }
            });
        });
    })  
})(jQuery);